import { EnumCookiesAuth } from "@tiendeo/auth/dist/EnumCookiesAuth";
import { useServices } from "contexts/ServiceContext";
import useInvalidateProfileQuery from "queries/useInvalidateProfileQuery";
import { useCallback } from "react";

const useLogout = () => {
    const invalidateProfileQuery = useInvalidateProfileQuery();
    const services = useServices();

    return useCallback(async () => {
        await services.AuthApi.Logout(services.AuthApiClient.GetAccessToken());

        services.CookiesClient.Delete(EnumCookiesAuth.ACCESS_TOKEN);
        services.CookiesClient.Delete(EnumCookiesAuth.END_USER_ID);
        services.CookiesClient.Delete(EnumCookiesAuth.EXPIRATION_ACCESS_TOKEN);

        invalidateProfileQuery();
    }, [services.AuthApiClient, services.AuthApi, services.NavigationService]);
};

export default useLogout;
